import { useEffect } from 'react';

let currentOverride = null;

export function getMillSelectOverride() {
  return currentOverride;
}

export function useMillSelectOverride(handler) {
  useEffect(() => {
    currentOverride = handler ?? null;
    return () => {
      if (currentOverride === (handler ?? null)) {
        currentOverride = null;
      }
    };
  }, [handler]);
}
